import React from 'react';
import { Icon, IconButton, makeStyles } from '@material-ui/core';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { availabilitiesPeriod } from '../../config/config';

const useStyles = makeStyles((theme) => ({
  container: {
    height: 4,
    display: 'flex',
    justifyContent: 'flex-end',
  },
  iconButton: {
    width: 28,
    height: 28,
    marginLeft: theme.spacing(1),
    border: '1px solid',
  },
  disabled: {
    color: theme.palette.grey[300],
    '& .MuiTouchRipple-root': {
      display: 'none',
    },
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

const today = dayjs();

const CalendarWeekPickerNavBar = ({
  onPreviousClick,
  onNextClick,
  nextMonth,
  previousMonth,
}) => {
  const classes = useStyles();

  const isNextDisabled = () => dayjs(nextMonth).isAfter(today.add(availabilitiesPeriod.nb, availabilitiesPeriod.unit), 'month');

  const isPrevDisabled = () => dayjs(previousMonth).isBefore(today, 'month');

  return (
    <div className={classes.container}>
      <IconButton
        className={`${classes.iconButton} ${isPrevDisabled() ? classes.disabled : ''}`}
        size="small"
        color="primary"
        onClick={() => onPreviousClick()}
      >
        <Icon>navigate_before</Icon>
      </IconButton>

      <IconButton
        className={`${classes.iconButton} ${isNextDisabled() ? classes.disabled : ''}`}
        size="small"
        color="primary"
        onClick={() => onNextClick()}
      >
        <Icon>navigate_next</Icon>
      </IconButton>
    </div>
  );
};

CalendarWeekPickerNavBar.propTypes = {
  onPreviousClick: PropTypes.func.isRequired,
  onNextClick: PropTypes.func.isRequired,
  nextMonth: PropTypes.instanceOf(Date).isRequired,
  previousMonth: PropTypes.instanceOf(Date).isRequired,
};

export default CalendarWeekPickerNavBar;
